export const STATUS_DEFINITIONS = [
  { id: 1, key: 'OPEN', label: 'OPEN' },
  { id: 2, key: 'START', label: 'START' },
  { id: 3, key: 'STOP', label: 'STOP' },
  { id: 4, key: 'WORK_IN_PROGRESS', label: 'WORK IN PROGRESS' },
  { id: 5, key: 'SHIPPED_TO_KERRVILLE', label: 'SHIPPED TO KERRVILLE' },
  { id: 6, key: 'RECEIVED_BY_KERRVILLE', label: 'RECEIVED BY KERRVILLE' },
  { id: 7, key: 'WORK_IN_PROGRESS_BY_KERRVILLE', label: 'WORK IN PROGRESS BY KERRVILLE' },
  { id: 8, key: 'SHIPPED_TO_STORE_BY_KERRVILLE', label: 'SHIPPED TO STORE BY KERRVILLE' },
  { id: 9, key: 'READY_TO_SEND', label: 'READY TO SEND' },
  { id: 10, key: 'READY_TO_PICKUP', label: 'READY TO PICKUP' },
  { id: 11, key: 'ON_HOLD', label: 'ON HOLD' },
  { id: 12, key: 'COMPLETED', label: 'COMPLETED' },
  { id: 13, key: 'RETURN', label: 'RETURN' },
  { id: 14, key: 'CANCELLED', label: 'CANCELLED' },
] as const;

export type StatusDefinition = typeof STATUS_DEFINITIONS[number];
export type StatusKey = StatusDefinition['key'];
export type StatusId = StatusDefinition['id'];

export const STATUS_IDS: Record<StatusKey, StatusId> = STATUS_DEFINITIONS.reduce(
  (acc, def) => {
    acc[def.key] = def.id;
    return acc;
  },
  {} as Record<StatusKey, StatusId>
);

export const STATUS_LABELS: Record<StatusId, string> = STATUS_DEFINITIONS.reduce(
  (acc, def) => {
    acc[def.id] = def.label;
    return acc;
  },
  {} as Record<StatusId, string>
);

export const STATUS_OPTIONS = STATUS_DEFINITIONS.map(({ id, label }) => ({ id, label }));

export const STATUS_KEYS = STATUS_DEFINITIONS.map(({ key }) => key);

export const getStatusLabel = (id?: number | string | null) => {
  if (id == null) return '—';
  const numeric = typeof id === 'string' ? Number(id) : id;
  return STATUS_LABELS[numeric as StatusId] ?? '—';
};
